import i18n from 'i18n';
import { OutdoorCreativeListDataProvider } from './OutdoorCreativeListDataProvider';

enum COLUMNS {
  OUTDOOR_TYPE = 'outdoorType',
  DURATION = 'duration'
}

export class SandboxOutdoorCreativeListDataProvider extends OutdoorCreativeListDataProvider {
  getColumns() {
    const columns = super.getColumns();
    const durationColumn = columns.find(
      (column) => column.dataField === COLUMNS.DURATION
    );
    if (durationColumn) {
      durationColumn.formatter = (duration) =>
        `${duration} ${i18n.t('common.units.seconds')}`;
    }
    return columns;
  }
}
